import { ReactNode } from "react";
import * as Typography from "../../Element/Typography";
import BreadCrumbs from "../../Element/BreadCrumb";
import ResponsiveImage from "../../Element/ResponsiveImage";
//import css
import styles from "./exploremore.module.css";
import { BaseTeaserData, ImageCrop } from "../../Utility/dataTypes";
import { SummaryItemSmall } from "../../Block/SummaryItem/SummaryItem";

const { Heading } = Typography;

type ExploreMoreProps = {
  headingText: string;
  headingTextZH?: string;
  items: BaseTeaserData[];
  placeholder?: ImageCrop;
  skipImage?: boolean;
};

/**
 * This is explore more component which can be found mostly in
 * the right sidebar
 *
 */
function ExploreMore({
  headingText,
  headingTextZH,
  items,
  placeholder,
  skipImage,
}: ExploreMoreProps): ReactNode {
  return (
    <div className={styles.exploreMoreCard}>
      <div className={styles.cardHeading}>
        <Heading.SubHeading3 nameZH={headingTextZH}>
          {headingText}
        </Heading.SubHeading3>
      </div>

      {items.map((item, index) => {
        const imageData = item.image?.crops.original || placeholder;
        return (
          <div key={index} className={styles.cardBody}>
            {!skipImage && imageData && (
              <div className={styles.cardImage}>
                <a href={item.path}>
                  <ResponsiveImage
                    {...imageData}
                    displayWidth={105}
                    errorSrc={placeholder?.src}
                  />
                </a>
              </div>
            )}
            <div className={styles.cardSummary}>
              <SummaryItemSmall
                beforeTitle={<BreadCrumbs sections={item.sections} />}
                title={item.title}
                url={item.path}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ExploreMore;
